export {
  getLanguageCookie,
  setLanguageCookie,
  resolveStoredLanguage,
  syncLocalePreferenceOnLogin,
} from "./LanguagePreferenceService";
